import Field, { Input } from "../../ui/Field";
import PhoneInput from "../../ui/PhoneInput";
import BirthDateInput from "../../ui/BirthDateInput";
import a from "./auth.module.css";

export default function AuthField({
  label,
  hint,
  type = "text",
  value,
  onChange,
  onBlur,
  placeholder,
  name,
  autoComplete,
  required,
  minLength,
  asPhone = false,
  asBirthDate = false,
  max,
  min,
  inputMode,
  inputClassName = "",
}) {
  const inputCls = `${a.authInput} ${inputClassName}`.trim();
  return (
    <Field label={label} hint={hint}>
      {asPhone ? (
        <PhoneInput
          className={inputCls}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
        />
      ) : asBirthDate ? (
        <BirthDateInput
          className={inputCls}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder || "ДД.ММ.ГГГГ"}
          required={required}
          max={max}
          min={min}
        />
      ) : (
        <Input
          className={inputCls}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={inputMode}
          required={required}
          minLength={minLength}
          max={max}
          min={min}
        />
      )}
    </Field>
  );
}
